import SignalsUpdateView from "app/pages/sales-intelligence/sub-modules/signals/components/views/SignalsUpdateView/SignalsUpdateView";
import withTrackedSignalView from "app/pages/sales-intelligence/sub-modules/signals/hoc/withTrackedSignalView";
import withSignalUpdateSubmit from "../../hoc/withSignalUpdateSubmit";

const SignalsUpdateViewContainer = withTrackedSignalView(withSignalUpdateSubmit(SignalsUpdateView));

export default SignalsUpdateViewContainer;
